import { useSelector } from '../context/Redux';
import { tempViewStateSelector } from '../redux/selectors/tempViewState';
export function useTempFilters(viewId) {
  const tempViewState = useSelector(tempViewStateSelector)[viewId];
  return tempViewState ? tempViewState.filters : [];
}